module.exports = __webpack_public_path__ + "img/wifi.e1e9bb12.png";